import React from 'react';

import { logger } from '../lib/logger';

const defaultFallback = <h1>Something went wrong:( </h1>;

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(/*error*/) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    logger.error(error, errorInfo);
  }

  render() {
    const {
      props: { fallback = defaultFallback, children },
      state: { hasError },
    } = this;
    return hasError ? fallback : children;
  }
}
